import { Component, OnInit } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { AccountService } from '../account.service';
import { AuthService } from '../auth.service';
import { of } from 'rxjs';
import { MatSnackBar } from '@angular/material';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  claims: Object = null;

  constructor(
    private authService: AuthService,
    private accountService: AccountService,
    private snackbar: MatSnackBar,
  ) { }

  ngOnInit() {
    try {
      const token = localStorage.getItem('jwt');
      const [, claims, ] = token.split('.');
      const claimsj = JSON.parse(atob(claims));
      console.log('got claims from localstorage', claimsj);
      const exp = new Date(claimsj.exp * 1000);
      console.log('exp', exp);
      if (claimsj.exp > (new Date().getTime() / 1000)) {
        // this.snackbar.open('already logged in', 'OK', { duration: 5000 });
        this.claims = claimsj;
        this.authService.setTokens(token, token);
        console.log('claims', this.claims);
      }
    } catch (err) {
      console.error('could not get jwt from localstorage', err);
    }
  }

  login(email: string, password: string) {
    this.accountService.login(email, password).pipe(
      map(x => {
        const token = x.token;
        this.authService.setTokens(token, token);
        localStorage.setItem('jwt', token);
      }),
      catchError(err => {
        console.error('could not login', err);
        return of();
      }),
    ).subscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts